// extracted by mini-css-extract-plugin
var _1 = "AccordionControlButtons-modulebutton__fplbR";
var _2 = "AccordionControlButtons-moduledeleteButton__Ov3XM";
export { _1 as "button", _2 as "deleteButton" }
